const COLOR = {
  SECONDARY: "#6c757d",
  SUCCESS: "#28a745",
  INFO: "#17a2b8",
  WARNING: "#ffc107",
  DANGER: "#dc3545",
  LIGHT: "#f8f9fa",
  DARK: "#343a40",

  white: "#FFFFFF",
  whiteLilac: "#F8F9FA",
  green: "#31C759",
  red: "#FF453A",
  purple500: "#7A4BFF", // 122, 75, 255
  purple500_10: "#7A4BFF1A",
  purple500_50: "#7A4BFF5A",
  gray100: "#F2F3F5",
  gray200: "#E0E1E6", // 자동완성 hex
  gray300: "#D7D8E0",
  gray400: "#B5B6BD",
  gray500: "#8E8F95", // 자동완성 hex
  gray600: "#6F7075",
  gray900: "#1F2021",
  amber500: "#F5A623",
};

export const PALETTE = {
  primary: COLOR.purple500,
  primaryBackground: COLOR.purple500_50,
  primaryHover: COLOR.purple500_10,
  light: COLOR.white,
  background: COLOR.whiteLilac,
  backgroundDisabled: COLOR.gray100,
  border: COLOR.gray300,
  borderLight: COLOR.gray200,
  text: COLOR.gray900,
  textMid: COLOR.gray500,
  textSub: COLOR.gray400,
  textDisabled: COLOR.gray400,
  icon: COLOR.gray600,
  iconDisabled: COLOR.gray300,
  progressBackground: COLOR.gray100,
  progressCompleted: COLOR.green,
  error: COLOR.red,
  warning: COLOR.amber500, // 보류 등 주의
};

type BreakpointType =
  | "mobile"
  | "mobmax"
  | "tablet"
  | "laptop"
  | "lapmax"
  | "desktop";

type BreakPointDataType = { [key in BreakpointType]: number };
type BreakPointPxDataType = { [key in BreakpointType]: string };

export const BREAKPOINT: BreakPointDataType = {
  mobile: 576,
  mobmax: 576,
  tablet: 768,
  laptop: 1024,
  lapmax: 1280,
  desktop: 1440,
};

export const BREAKPOINTPX = Object.keys(BREAKPOINT).reduce((acc, key) => {
  const tmpKey = key as BreakpointType;
  const tmpAcc = acc as BreakPointPxDataType;
  tmpAcc[tmpKey] = `${BREAKPOINT[tmpKey]}px`;
  return tmpAcc;
}, {} as BreakPointPxDataType);

export const SIZE = {
  minWidth: 1000,
  headerHeight: 80,
};
